var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.noFormField
      ? _c(
          "div",
          { staticClass: "daterange-picker__container datepicker-cont" },
          [
            _c("date-picker", {
              attrs: {
                "prefix-class": "searchie",
                placeholder: _vm.placeholder,
                type: "date",
                range: _vm.range,
                inline: ""
              },
              on: { change: _vm.updateDate },
              model: {
                value: _vm.date,
                callback: function($$v) {
                  _vm.date = $$v
                },
                expression: "date"
              }
            })
          ],
          1
        )
      : _c(
          "div",
          {
            staticClass: "form-control form-control-date",
            class: [
              {
                "form-control-sm": _vm.small,
                "px-2": _vm.small,
                "py-0": _vm.small
              },
              _vm.placement
            ]
          },
          [
            _c(
              "div",
              { directives: [{ name: "click-away", rawName: "v-click-away" }] },
              [
                _vm._t("selector", [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker",
                      on: {
                        click: function($event) {
                          _vm.datePickerState = !_vm.datePickerState
                        }
                      }
                    },
                    [
                      !_vm.hideIcon
                        ? _c(
                            "svg",
                            {
                              staticClass: "mr-2",
                              class: { "icon-sm": _vm.small },
                              attrs: { viewBox: "0 0 24 24" }
                            },
                            [
                              _c("use", {
                                attrs: { "xlink:href": "#icon-calendar-edit" }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            "" +
                              _vm.dateFormat +
                              (_vm.type === "time" && _vm.date ? "h" : "")
                          ) +
                          "\n          "
                      ),
                      _vm.withCaret
                        ? _c(
                            "svg",
                            {
                              staticClass: "icon-regular caret ml-auto",
                              attrs: { viewBox: "0 0 24 24" }
                            },
                            [
                              _c("use", {
                                attrs: { "xlink:href": "#icon-chevron-down" }
                              })
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.datePickerState
                    ? _c(
                        "div",
                        { staticClass: "daterange-picker__container" },
                        [
                          _c("date-picker", {
                            attrs: {
                              "prefix-class": "searchie",
                              placeholder: _vm.placeholder,
                              type: _vm.type,
                              range: _vm.range,
                              inline: "",
                              "show-second": _vm.showSecond,
                              "disabled-date": _vm.isPastDateDisabled
                            },
                            on: { change: _vm.updateDate },
                            model: {
                              value: _vm.date,
                              callback: function($$v) {
                                _vm.date = $$v
                              },
                              expression: "date"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ],
              2
            )
          ]
        ),
    _vm._v(" "),
    _vm.hasControls
      ? _c(
          "div",
          { staticClass: "datepicker-controls px-2 py-2" },
          [
            _c(
              "b-btn",
              {
                attrs: { variant: "secondary" },
                on: { click: _vm.handleCancel }
              },
              [_vm._v("\n      Cancel\n    ")]
            ),
            _vm._v(" "),
            _c(
              "b-btn",
              {
                attrs: { variant: "primary" },
                on: {
                  click: function($event) {
                    return _vm.$emit("change", _vm.date)
                  }
                }
              },
              [_vm._v("\n      Apply\n    ")]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }